import {
    Avatar,
    FormControl,
    Grid2,
    IconButton,
    MenuItem,
    Select,
    TextField,
    Tooltip,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { CUSTOM_FIELDS_TYPES } from '../../../../helpers/constants';
import stringAvatar from './helpers/stringAvatar';
import convertFieldNameDate from './helpers/convertFieldNameDate';

const CustomOneFieldRenderer = ({ field, setField, removeField }) => {
    const { t } = useTranslation();

    // these fields can be:
    // - old custom notes can only be deleted but not modified (ticketField = false and oldNote = true)

    const cannotDelete = field.ticketField;
    const cannotEdit = field.oldNote && !field.ticketField;

    // remove translate button during edit, no need to translate
    const translateButton = null;

    let deleteBlock = (
        <Grid2
            size={{ xs: 2, sm: 1 }}
            sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}
        >
            <Tooltip title={t('tickettypes.removeNote')}>
                <span>
                    <IconButton onClick={removeField}>
                        <DeleteIcon />
                    </IconButton>
                </span>
            </Tooltip>
        </Grid2>
    );
    if (cannotDelete) {
        deleteBlock = false;
    }

    // Field takes the row minus the delete button; on mobile the button needs a
    // wider slot so it does not overflow, so the field drops one column at xs.
    const fieldGridSize = deleteBlock ? { xs: 10, sm: 11 } : { xs: 12 };

    if (field.type === CUSTOM_FIELDS_TYPES.DROPDOWN) {
        return (
            <>
                <Grid2 size={fieldGridSize}>
                    <FormControl fullWidth>
                        <Select
                            displayEmpty
                            renderValue={(selected) =>
                                selected || (
                                    <span style={{ opacity: 0.6 }}>
                                        {field.name}
                                        {field.required ? ' *' : ''}
                                    </span>
                                )
                            }
                            sx={{ '& .MuiSelect-select': { textAlign: 'left', paddingLeft: 0 } }}
                            fullWidth
                            value={field.value || ''}
                            required={field.required}
                            disabled={cannotEdit}
                            onChange={(ev) => {
                                setField(ev.target.value);
                            }}
                        >
                            {Array.isArray(field.description) &&
                                field.description.map((line) => (
                                    <MenuItem value={line} key={line}>
                                        {line}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid2>
                {translateButton}
                {deleteBlock}
            </>
        );
    }

    if (field.type === CUSTOM_FIELDS_TYPES.CHAT) {
        return (
            <>
                <Grid2 size={fieldGridSize}>
                    <Grid2 container spacing={2} sx={{ mb: 2 }}>
                        <Grid2 sx={{ alignContent: 'center' }}>
                            <Tooltip title={field.user?.name || 'Guest'}>
                                <Avatar {...stringAvatar(field.user?.name)} />
                            </Tooltip>
                        </Grid2>
                        <Grid2 style={{ flex: 1 }}>
                            <TextField
                                fullWidth
                                required={field.required}
                                multiline
                                disabled={cannotEdit}
                                label={convertFieldNameDate(field.name)}
                                value={field.value || ''}
                                onChange={(ev) => {
                                    setField(ev.target.value);
                                }}
                            />
                        </Grid2>
                    </Grid2>
                </Grid2>
                {translateButton}
                {deleteBlock}
            </>
        );
    }

    // default is text field and multiline
    return (
        <>
            <Grid2 size={fieldGridSize}>
                <TextField
                    fullWidth
                    required={field.required}
                    multiline={field.type === CUSTOM_FIELDS_TYPES.MULTI}
                    disabled={cannotEdit}
                    label={field.name}
                    value={field.value || ''}
                    onChange={(ev) => {
                        setField(ev.target.value);
                    }}
                />
            </Grid2>
            {translateButton}
            {deleteBlock}
        </>
    );
};

export default CustomOneFieldRenderer;
